import { Link } from 'gatsby';
import styled from 'styled-components';
import sprites from '../../assets/svg/sprites.svg';

export const InnerBanner = styled.section`
  position: relative;
  z-index: 9;
  margin-top: 142px;
  height: 500px;
  overflow: hidden;

  .cTitle {
    margin: 0 0 2rem !important;
    display: inline-block;
    position: relative;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    color: #fff;

    &:after {
      content: '';
      display: block;
      width: 50%;
      margin: 1rem auto;
      height: 1px;
      background-color: #fff;
    }
  }
  span {
    .sustainablity-page {
      @media (max-width: 1099px) {
        height: 200px !important;
      }
    }
  }
  @media (max-width: 1199.98px) {
    height: 445px;
    &.sustainablity-page {
      height: 200px !important;
    }
  }

  @media (max-width: 1099px) {
    margin-top: 110px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }

  &.banner_stats {
    flex-flow: inherit;

    & > .lazy-load-image-background {
      display: block !important;
      height: 100%;
      width: 100vw !important;
    }

    @media (max-width: 767px) {
      height: 550px;
    }

    .inner_bnr {
      @media (max-width: 767px) {
        height: 550px;
      }
    }
  }

  &.video_section {
    height: 500px;

    @media (max-width: 1199.98px) {
      height: 445px;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      z-index: 1;
    }

    .video_description {
      @media (max-width: 767.98px) {
        padding-top: 100px;
      }
    }

    iframe {
      @media (max-width: 575.98px) {
        height: 100% !important;
        width: 1280px !important;
        min-height: auto;
      }
    }

    &.smallbanner {
      @media (max-width: 767.98px) {
        height: 206px;
      }

      .description_banner {
        @media (max-width: 767.98px) {
          text-align: center;
          p {
            display: none;
          }
        }
      }
    }
  }

  .slick-next {
    right: 50px;
    z-index: 9;

    @media (max-width: 768px) {
      right: 0px;
    }

    &:before {
      border: solid #fff;
      border-width: 0 4px 4px 0;
    }
  }

  .slick-prev {
    left: 50px;
    z-index: 9;

    @media (max-width: 768px) {
      left: 20px;
    }

    &:before {
      border: solid #fff;
      border-width: 0 4px 4px 0;
    }
  }

  .inner_bnr {
    position: relative;
    width: 100vw;
    object-fit: cover;
    object-position: top center;
    height: 500px;

    @media (max-width: 1199.98px) {
      height: 445px;
    }
  }

  .inner_bnr:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }
  &.small_hero_banner {
    @media (max-width: 767.98px) {
      height: 223px;
    }
  }

  @media (max-width: 767.98px) {
    height: 445px;
  }

  &.banner_padding {
    .description_banner {
      @media (max-width: 767.98px) {
        padding-top: 100px;
      }
    }
  }
`;

export const BannerImage = styled.img`
  width: 100vw;
  object-fit: cover;

  span {
    &.lazy-load-image-background {
      display: block !important;
      height: 100%;

      img {
        transition: 0.5s !important;
      }
    }
  }
`;

export const BannerDescription = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  & > div {
    width: 730px;
    text-align: center;
    z-index: 10;

    @media (max-width: 767.98px) {
      width: inherit;
      text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};
    }
  }
  .container_wrapper {
    @media (max-width: 767.98px) {
      width: 100%;
    }
  }
`;

export const BannerHeading = styled.h1`
  font-size: 50px;
  line-height: 60px;
  margin: 0;
  color: #fff;
  text-align: center;
  font-weight: 400;

  &[dir='rtl'] {
    font-family: GEAwtarDWTCMedium, sans-serif;
  }

  &[dir='ltr'] {
    font-family: 'LibreBaskervilleRegular';
  }

  @media (max-width: 767.98px) {
    font-size: 30px;
    line-height: 40px;
    padding-top: 0px;
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'center')};
  }
`;

export const BannerP = styled.p`
  color: #fff;
  margin: 2rem 0 0;
  text-align: center;
  font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
  line-height: ${({ dir }) => (dir === 'rtl' ? '28px' : '20px')};
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};

  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};

  @media (max-width: 767.98px) {
    margin-top: 1.5rem;
    font-size: ${({ dir }) => (dir === 'rtl' ? '16px' : '')};
    text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : '')};
  }
`;

export const IframeVideo = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  overflow: hidden;

  & > iframe {
    border: none;
    outline: none;
    width: 100vw;
    height: 56.25vw;
    min-height: 100vh;
    min-width: 177.77vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
    }
  }
  video {
    border: none;
    outline: none;
    width: 100vw;
    height: 56.25vw;
    min-height: 100vh;
    min-width: 177.77vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 1500px) {
      width: 1920px;
      height: 1080px;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
    }
  }

  &.video_banner {
    iframe {
      @media (max-width: 1500px) {
        width: 1920px;
        height: 1080px;
      }
    }
  }
`;

export const BreadCrumb = styled.div`
  background-color: #fff;
  padding-left: 0;
  padding-right: 0;
  margin: 1rem 0 0;
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  list-style: none;
  border-radius: 0.25rem;

  @media (max-width: 992px) {
    background-color: transparent;
    margin-top: -70px;
    margin-bottom: 0;
    position: relative;
  }
`;

export const BreadCrumbTag = styled(Link)`
  font-size: 12px;
  text-transform: uppercase;
  color: #000;
  cursor: pointer;

  &:before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 10px;
    background: url(${sprites}#viewarrow) no-repeat;
    margin: 10px 10px 0 0;
    transform: rotate(180deg);
  }

  &:hover {
    color: #1b7bdd;
    text-decoration: underline;
  }
  @media (max-width: 992px) {
    color: #fff;
  }
`;

export const InnerBannerStaticImage = styled.img`
  object-fit: cover;
  height: 100%;
`;

export const FiguresDetails = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 2rem 0 0;
  color: #fff;

  @media (max-width: 768px) {
    padding: 3rem 0 0;
    justify-content: space-around;
    flex-wrap: wrap;
  }
`;

export const FSize = styled.div`
  &[dir='ltr'] {
    text-align: left;
  }
  &[dir='rtl'] {
    text-align: right;
  }
  @media (max-width: 767.98px) {
    margin-right: 0;
    max-width: calc(50% - 20px);
  }
`;

export const NumText = styled.div`
  font-size: 20px;
  line-height: 30px;
  @media (max-width: 767.98px) {
    font-size: 15px;
  }

  &:after {
    display: block;
    content: '';
    position: relative;
    margin: 5px 0;
    width: 100%;
    height: 1px;
    background: #1b7bdd;
  }
`;

export const Num = styled.div`
  font-size: 48px;
  line-height: 60px;

  span {
    &[dir='rtl'] {
      font-family: 'DIN Regular', sans-serif;
    }
  }

  @media (max-width: 767.98px) {
    font-size: 30px;
    line-height: 30px;
    margin-top: 10px;
  }
`;

export const FHeight = styled.div``;

export const HeroSearch = styled.div``;

export const SearchSpan = styled.div``;
export const Time = styled.p`
  margin: 2rem 0 0;
  color: #fff;
  text-transform: uppercase;
`;
